
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { PlanChangeStatuses } from '@/types/PlanStatus';

@Component
export default class PlanChangeFeedback extends Vue {
  @Prop({
    required: false,
    default: null,
    type: String,
  }) readonly planChangeStatus!: string | null;

  hasProp = false;

  mounted() {
    this.checkAsyncProp();
  }

  @Watch('planChangeStatus', { immediate: true })
  checkAsyncProp() {
    if (this.planChangeStatus) {
      this.hasProp = true;
    }
  }

  get wasDenied(): boolean {
    return this.planChangeStatus === PlanChangeStatuses.CREDIT_REJECTION;
  }
}
